import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { useNavigate, useParams } from "react-router-dom"
import Send from "../../core/communication"
import { useUploadFile } from "../../core/utils/hooks/uploadItem"
import { isValidURL } from "../../core/utils/validateFields"
import AssistanceAnalysisReportsScreen from "../../screen/AssistanceAnalysisReportsScreen"
import { clearFields } from "../AssistanceAnalysisContainer"
import { useScope } from "../SelectProjectCompanyContainer"
import mockChart from "../../core/mocks/typeChart/struct.json"
import { sort } from "fast-sort"
import { useDispatch } from "react-redux"
import { setData } from "../../core/redux/app/Actions"
import { useSelector } from "react-redux"

const AssistanceAnalysisReportsContainer = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { scope } = useScope()
  const dispatch = useDispatch()
  const clusteredTopicsSaved = useSelector((state) => state.app.clusteredTopicsSaved)
  const clusteredTopicsSavedId = useSelector((state) => state.app.clusteredTopicsSavedId)
  const {
    register,
    resetField,
    setValue,
    handleSubmit,
    watch,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
  })

  const [reloadData, setReloadData] = useState(false)
  const [reportData, setReportData] = useState([])
  const [modalIsOpen, setModalIsOpen] = useState({
    newClusteredIsOpen: false,
    newListIsOpen: false,
    newPathTopicsIsOpen: false,
  })
  const [loading, setLoading] = useState(false)
  const [uploadedImage, setUploadedImage] = useState(false)
  const [errorImage, setErrorImage] = useState(false)
  const [processingFile, setProcessingFile] = useState(false)
  const [selectedCard, setSelectedCard] = useState(clusteredTopicsSavedId)
  const [reportPathImage, setReportPathImage] = useState({})
  const [clusteredPathTopics, setClusteredPathTopics] = useState(clusteredTopicsSaved || [])
  const linkImageFieldWatch = watch("linkImage")

  const loadDataReports = async () => {
    try {
      const response = await Send.get(`/report-chart-list/${id}`)
      setReportData(sort(response).desc("createdAt"))
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    loadDataReports()
  }, [id, reloadData])

  const reload = () => {
    setReloadData(!reloadData)
  }

  useEffect(() => {
    if (modalIsOpen.newListIsOpen) {
      setValue("title", reportData.title)
      setValue("linkImage", reportData.image)
      setValue("description", reportData.description)
    } else {
      clearFields(resetField)
    }
  }, [modalIsOpen])

  useEffect(() => {
    dispatch(
      setData({
        clusteredTopicsSaved: clusteredPathTopics,
        clusteredTopicsSavedId: selectedCard,
      }),
    )
  }, [selectedCard])

  useEffect(() => {
    if (linkImageFieldWatch?.length && isValidURL(linkImageFieldWatch)) {
      setReportPathImage({})
      setUploadedImage(false)
    }
    return
  }, [linkImageFieldWatch])

  useEffect(() => {
    if (uploadedImage) {
      resetField(uploadedImage && "linkImage", { keepError: false })
    }
    return
  }, [uploadedImage])

  const onChangeFile = (e) => {
    const files = e.target.files
    const fileReader = new FileReader()

    fileReader.fileName = files[0]?.name
    fileReader.readAsDataURL(files[0])

    fileReader.onload = (event) => {
      const fileName = event.target?.fileName || ""
      const newDataFile = { data: event.target.result, type: fileName.split(".").pop() }

      setReportPathImage(newDataFile)
      setUploadedImage(true)
    }
    e.target.value = null
  }

  const updateListReportChart = async (data) => {
    const { title, linkImage, description, order } = data

    setLoading(true)

    let imageUpload = ""

    if (reportPathImage?.data) {
      setProcessingFile(true)
      imageUpload = await useUploadFile(reportPathImage?.data, setErrorImage, reportPathImage?.type)
      setProcessingFile(false)
    }

    try {
      await Send.put(`/report-chart-list/${id}`, {
        title,
        image: linkImage || imageUpload,
        order,
        description,
        projectId: scope?.id,
      })
      setModalIsOpen({ newListIsOpen: false })
      reload()
      setLoading(false)
    } catch (error) {
      console.log("err", error)
      //setErrorSave("Erro ao salvar")
    }

    clearFields(resetField)
  }

  const saveNewPathTopics = async (data) => {
    const { title, order, linkImage } = data
    setLoading(true)

    let imageUpload = ""

    if (reportPathImage?.data) {
      setProcessingFile(true)
      imageUpload = await useUploadFile(reportPathImage?.data, setErrorImage, reportPathImage?.type)
      setProcessingFile(false)
    }

    try {
      await Send.post("/path-topics", {
        title,
        order,
        reportListPathId: id,
        image: linkImage || imageUpload,
      })
      setModalIsOpen({ newPathTopicsIsOpen: false })
      setLoading(false)
    } catch (error) {
      console.log("err", error)
    }

    clearFields(resetField)
    
  }

  const showPreviewClusteredPathTopics = (item) => {
    const { clustered_charts } = item
    setClusteredPathTopics(formatCharts(clustered_charts))
    setSelectedCard(item.id)
  }

  const gotToClusteredPathTopics = (item) => {
    navigate(`/assistance/analysis/reports/clustered/${item.id}`, {
      state: {
        components: item.components,
        charts: JSON.parse(item?.charts),
        clustered: {
          title: item.title,
        },
      },
    })
  }

  const checkExistsChartOnReportList = () => {
    const check = reportData?.path_topics
      ?.map((topics) => topics)
      .filter((topic) => topic.id === selectedCard)

    if (check?.length > 0) {
      return clusteredPathTopics
    } else {
      return []
    }
  }

  return (
    <AssistanceAnalysisReportsScreen
      {...{
        reportData,
        showPreviewClusteredPathTopics,
        gotToClusteredPathTopics,
        register,
        errors,
        loading,
        modalIsOpen,
        setModalIsOpen,
        onChangeFile,
        clusteredPathTopics: checkExistsChartOnReportList(),
        uploadedImage,
        processingFile,
        selectedCard,
      }}
      onSaveReportListPath={handleSubmit(updateListReportChart)}
      onSavePathTopics={handleSubmit(saveNewPathTopics)}
    />
  )
}

export default AssistanceAnalysisReportsContainer

const formatCharts = (item) => {
  const formatFakeChart = mockChart.flatMap((chart) =>
    item.map((clust, index2) => {
      return {
        ...clust,
        components: JSON.parse(clust.charts).flatMap((chart2) =>
          chart.components.map((comp, index) => {
            return {
              ...comp,
              type: chart2.type,
              question: chart2.question,
            }
          }),
        ),
      }
    }),
  )

  return formatFakeChart
}
